import React, { useState } from 'react';
import { MessageCircle, Phone, HelpCircle, X, MessageSquare } from 'lucide-react';
export function FloatingContact() {
  const [isOpen, setIsOpen] = useState(false);
  const scrollToRecursos = () => {
    setIsOpen(false);
    const recursos = document.getElementById('recursos');
    if (recursos) {
      recursos.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="fixed bottom-6 right-6 z-[9999] flex flex-col items-end" data-id="element-61">
      {/* Ventana Desplegable */}
      <div className={`mb-4 bg-white w-72 sm:w-80 rounded-2xl shadow-2xl border border-gray-100 overflow-hidden transition-all duration-300 origin-bottom-right ${isOpen ? 'scale-100 opacity-100' : 'scale-0 opacity-0 pointer-events-none'}`} data-id="element-62">
        <div className="bg-sylmar p-4 text-white flex justify-between items-center" data-id="element-63">
          <div data-id="element-64">
            <h3 className="font-bold text-lg leading-tight" data-id="element-65">
              ¿Necesitas ayuda?
            </h3>
            <p className="text-sylmar-light text-xs" data-id="element-66">
              Estamos aquí para escucharte
            </p>
          </div>
          <button onClick={() => setIsOpen(false)} className="text-white/80 hover:text-white bg-white/10 hover:bg-white/20 p-1.5 rounded-full transition-colors" data-id="element-67">
            <X className="w-5 h-5" data-id="element-68" />
          </button>
        </div>

        <div className="p-4 flex flex-col gap-3 bg-gray-50/50" data-id="element-69">
          {/* Botón WhatsApp */}
          <a href="https://wa.me/18188338737" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-white hover:bg-green-50 p-3 rounded-xl border border-gray-100 hover:border-green-200 transition-all group shadow-sm" data-id="element-70">
            <div className="bg-green-100 p-2 rounded-lg text-green-600 group-hover:bg-green-500 group-hover:text-white transition-colors" data-id="element-71">
              <MessageCircle className="w-5 h-5" data-id="element-72" />
            </div>
            <div data-id="element-73">
              <p className="font-bold text-charcoal text-sm group-hover:text-green-700 transition-colors" data-id="element-74">
                Mensaje de WhatsApp
              </p>
              <p className="text-xs text-gray-500" data-id="element-75">Respuestas rápidas</p>
            </div>
          </a>

          {/* Botón Llamada */}
          <a href="tel:8188338737" className="flex items-center gap-3 bg-white hover:bg-sky/10 p-3 rounded-xl border border-gray-100 hover:border-sky/30 transition-all group shadow-sm" data-id="element-76">
            <div className="bg-sky/20 p-2 rounded-lg text-sky-dark group-hover:bg-sky group-hover:text-white transition-colors" data-id="element-77">
              <Phone className="w-5 h-5" data-id="element-78" />
            </div>
            <div data-id="element-79">
              <p className="font-bold text-charcoal text-sm group-hover:text-sky-dark transition-colors" data-id="element-80">
                Llamar por Teléfono
              </p>
              <p className="text-xs text-gray-500" data-id="element-81">(818) 833-8737</p>
            </div>
          </a>

          {/* Botón Directorio de Recursos */}
          <button onClick={scrollToRecursos} className="flex items-center gap-3 bg-white hover:bg-warm/20 p-3 rounded-xl border border-gray-100 hover:border-warm transition-all group shadow-sm text-left w-full" data-id="element-82">
            <div className="bg-warm/40 p-2 rounded-lg text-charcoal group-hover:bg-warm transition-colors" data-id="element-83">
              <HelpCircle className="w-5 h-5" data-id="element-84" />
            </div>
            <div data-id="element-85">
              <p className="font-bold text-charcoal text-sm" data-id="element-86">
                Directorio de Recursos
              </p>
              <p className="text-xs text-gray-500" data-id="element-87">
                Más de 100 contactos comunitarios
              </p>
            </div>
          </button>
        </div>
      </div>

      {/* Botón Flotante Principal */}
      <button onClick={() => setIsOpen(!isOpen)} className={`relative flex items-center justify-center w-14 h-14 rounded-full shadow-2xl text-white transition-transform hover:scale-110 duration-300 ${isOpen ? 'bg-charcoal rotate-90' : 'bg-sylmar hover:bg-sylmar-dark'}`} data-id="element-88">
        {/* Efecto de pulso cuando está cerrado */}
        {!isOpen && <span className="absolute inset-0 rounded-full bg-sylmar animate-ping opacity-40" data-id="element-89"></span>}

        {isOpen ? <X className="w-6 h-6 -rotate-90 transition-transform" data-id="element-90" /> : <MessageSquare className="w-6 h-6" data-id="element-91" />}
      </button>
    </div>;
}